module.exports = __webpack_public_path__ + "static/media/tick.b685cef5.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/tick.mp3
// module id = 521
// module chunks = 0